import { Component } from '@angular/core';

@Component({
  selector: 'user-manual-approval-field',
  template: `
    <strong class="user-approval-mode"><text key="MANUAL_APPROVAL_LABEL"></text></strong>
    <p class="info"><text key="MANUAL_APPROVAL_INFO"></text></p>
  `
})
export class UserManualApprovalFieldComponent {}